<template>
  <div class="component-upload-image">
    <div class="imgBox" @paste="handlePaste">
    <el-upload
      :action="uploadImgUrl"
      list-type="picture-card"
      :on-success="handleUploadSuccess"
      :before-upload="handleBeforeUpload"
      :limit="limit"
      ref="uploadMutiple"
      :on-error="handleUploadError"
      :on-exceed="handleExceed"
      name="file"
      :on-remove="handleRemove"
      :show-file-list="true"
      :file-list="fileList"
      :on-preview="handlePictureCardPreview"
      :class="[{hide: (this.fileList.length >= this.limit) || isDisabled},{showImgs: isDisabled}]"
    >
      <i class="el-icon-plus"></i>
    </el-upload>
    <div id="preview" class="pasteTip" v-if="showPaste">
      <span class="f12"><i class="el-icon-s-opportunity" style="color:#FB894C;"></i>点击此处 将图片按Ctrl+V 粘贴至此处</span>
    </div>
    </div>
    <!-- 上传提示 -->
    <div class="el-upload__tip" slot="tip" v-if="showTip">
      <div v-if="from == 'brandDealer'">
        <span class="qianhText">1，显示logo大小130*35</span>
        <span class="qianhText">2，如果上传图片过大则会压缩，请注意 （非必填）</span>
      </div>
      <div v-else>
        <template v-if="fileSize">请上传大小不超过 <b style="color: #f56c6c">{{ fileSize }}MB</b> </template>
        <template v-if="fileType"> 格式为 <b style="color: #f56c6c">{{ fileType.join("/") }}</b>的文件 </template>
        <template v-if="limitTip">最多上传<b style="color: #f56c6c">{{limit}}</b>张</template>
      </div>
    </div>
    <!-- 大图预览 -->
    <el-image ref="preview" style="display: none" :src="imagePreviewUrls[initialImgPreviewIndex]" :preview-src-list="imagePreviewUrls"></el-image>
<!--    <el-image-viewer-->
<!--      v-if="dialogVisible"-->
<!--      :on-close="closeImgViewer"-->
<!--      :url-list="imagePreviewUrls"-->
<!--      :z-index="3000"-->
<!--      :initial-index="initialImgPreviewIndex"-->
<!--    />-->

<!--    <el-dialog-->
<!--      :visible.sync="dialogVisible"-->
<!--      title="预览"-->
<!--      width="800"-->
<!--      customClass="dialogImg"-->
<!--      v-dialogDrag="false"-->
<!--      append-to-body-->
<!--    >-->
<!--      <img-->
<!--        :src="dialogImageUrl"-->
<!--        style="display: block; max-width: 100%; max-height: 700px; margin: 0 auto"-->
<!--      />-->
<!--    </el-dialog>-->
  </div>
</template>

<script>
import { getToken } from "@/utils/auth";
// import ElImageViewer from 'element-ui/packages/image/src/image-viewer'

export default {
  props: {
    from: String,
    value: [String, Object, Array],
    // 图片数量限制
    limit: {
      type: Number,
      default: 1,
    },
    // 大小限制(MB)
    fileSize: {
       type: Number,
      default: 5,
    },
    limitTip:{
      type: Boolean,
      default: false
    },
    // 文件类型, 例如['png', 'jpg', 'jpeg']
    fileType: {
      type: Array,
      default: () => ["png", "jpg", "jpeg"],
    },
    // 是否显示提示
    isShowTip: {
      type: Boolean,
      default: true
    },
    // 是否置灰
    isDisabled: {
      type: Boolean,
      default: false
    },
    //是否开启粘贴图片
    showPaste: {
      type: Boolean,
      default: false
    }
  },
  components: {
    // ElImageViewer
  },
  data() {
    return {
      dialogImageUrl: "",
      dialogVisible: false,
      hideUpload: false,
      baseUrl: 'https://djy-static-img-01.oss-cn-hangzhou.aliyuncs.com/',
      uploadImgUrl: process.env.VUE_APP_BASE_API + "/common/upload", // 上传的图片服务器地址
      headers: {
        // Authorization: "Bearer " + getToken(),
      },
      fileList: [],
      initialImgPreviewIndex:0, // 预览打开看到的图片下标
      imagePreviewUrls:[], // 预览图片的数组
    };
  },
  watch: {
    value: {
      handler(val) {
        if (val) {
          // 首先将值转为数组
          const list = Array.isArray(val) ? val : this.value.split(',');
          // 然后将数组转为对象数组
          this.fileList = list.map(item => {
            if (typeof item === "string") {
              if (item.indexOf(this.baseUrl) === -1) {
                item = { name: this.baseUrl + item, url: this.baseUrl + item };
              } else {
                  item = { name: item, url:  item };
              }
            }
            return item;
          });
          this.imagePreviewUrls = this.listToImgArr(this.fileList);
        } else {
          this.fileList = [];
          return [];
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    // 是否显示提示
    showTip() {
      return this.isShowTip && (this.fileType || this.fileSize);
    },
  },
  methods: {
    //粘贴图片
    handlePaste(event) {
      console.log("event",event)
      if(this.showPaste) {
        const items = (event.clipboardData || window.clipboardData).items;
        console.log("items",items)
        let file = null;
        if (!items || items.length === 0) {
          this.$message.error("当前浏览器不支持本地");
          return;
        }
        // 搜索剪切板items
        for (let i = 0; i < items.length; i++) {
          console.log("剪切板items",items)
          if (items[i].type.indexOf("image") !== -1) {
            file = items[i].getAsFile();
            break;
          }
        }
        console.log("file",file)
        console.log("!file",!file)
        if (!file) {
          this.$message.error("粘贴内容非图片");
          return;
        }
        if (this.fileList.length >= this.limit) {
          this.$message.error(`上传文件数量不能超过 ${this.limit} 个!`); // 图片数量超出
          return
        }
        this.$refs.uploadMutiple.handleStart(file); // 将粘贴过来的图片加入预上传队列
        this.$refs.uploadMutiple.submit(); // 提交图片上传队列
      }
    },
    // 删除图片
    handleRemove(file, fileList) {
      const findex = this.fileList.map(f => f.name).indexOf(file.name);
      if(findex > -1) {
        this.fileList.splice(findex, 1);
        this.$emit("input", this.listToString(this.fileList));
      }
    },
    // 上传成功回调
    handleUploadSuccess(res) {
      this.fileList.push({ name: res.url, url: res.url });
      this.$emit("input", this.listToString(this.fileList));
      this.loading.close();
      this.imagePreviewUrls = this.listToImgArr(this.fileList);
    },
    // 上传前loading加载
    handleBeforeUpload(file) {
      let isImg = false;
      if (this.fileType.length) {
        let fileExtension = "";
        if (file.name.lastIndexOf(".") > -1) {
          fileExtension = file.name.slice(file.name.lastIndexOf(".") + 1);
        }
        isImg = this.fileType.some(type => {
          if (file.type.indexOf(type) > -1) return true;
          if (fileExtension && fileExtension.indexOf(type) > -1) return true;
          return false;
        });
      } else {
        isImg = file.type.indexOf("image") > -1;
      }

      if (!isImg) {
        this.$message.error(
          `文件格式不正确, 请上传${this.fileType.join("/")}图片格式文件!`
        );
        return false;
      }
      if (this.fileSize) {
        const isLt = file.size / 1024 / 1024 < this.fileSize;
        if (!isLt) {
          this.$message.error(`上传头像图片大小不能超过 ${this.fileSize} MB!`);
          return false;
        }
      }
      this.loading = this.$loading({
        lock: true,
        text: "上传中",
        background: "rgba(0, 0, 0, 0.7)",
      });
    },
    // 文件个数超出
    handleExceed() {
      this.$message.error(`上传文件数量不能超过 ${this.limit} 个!`);
    },
    // 上传失败
    handleUploadError() {
      this.$message({
        type: "error",
        message: "上传失败",
      });
      this.loading.close();
    },
    // 预览
    handlePictureCardPreview(file) {
      this.imagePreviewUrls = this.listToImgArr(this.fileList);
      let index = this.imagePreviewUrls.indexOf(file.url)
      if (index >= 0) {
        this.initialImgPreviewIndex = index
      }
      // this.dialogImageUrl = file.url;
      // this.dialogVisible = true;
      // console.log(111)
      this.$refs.preview.clickHandler()
    },
    // 对象转成指定字符串分隔
    listToString(list, separator) {
      let strs = "";
      separator = separator || ",";
      for (let i in list) {
        strs += list[i].url.replace(this.baseUrl, "") + separator;
      }
      return strs != '' ? strs.substr(0, strs.length - 1) : '';
    },
    // 提取图片数组
    listToImgArr(list) {
      let imgArr = [];
      for (let i in list) {
        imgArr.push(list[i].url);
      }
      return imgArr;
    },
    closeImgViewer () {
      this.dialogVisible = false
    },
  }
};
</script>
<style scoped lang="scss">
// .el-upload--picture-card 控制加号部分
::v-deep.hide .el-upload--picture-card {
    display: none;
}
// 去掉动画效果
::v-deep .el-list-enter-active,
::v-deep .el-list-leave-active {
    transition: all 0s;
}

::v-deep .el-list-enter, .el-list-leave-active {
    opacity: 0;
    transform: translateY(0);
}
  .qianhText{font-size:12px; color:#9e9e9e; display:block; line-height: 20px;}
  .el-upload__tip{margin-top: 0}
  ::v-deep .dialogImg{ margin-left: 400px; margin-top: 10px !important;}
::v-deep.showImgs .el-upload-list--picture-card .el-upload-list__item-actions .el-upload-list__item-delete{display: none;}
</style>

